import ImagePreview from '../../components/admin/ui/ImagePreview';

export const technologyCategoryColumns = [{ key: 'label', label: 'Libellé', render: (row) => row.label?.fr }];

export const technologyCategoryFields = [{ name: 'label', label: 'Libellé', type: 'bilingual', required: true }];

export const getTechnologyColumns = (categories) => [
  { key: 'icon', label: '', render: (row) => <ImagePreview src={row.icon} size={32} /> },
  { key: 'label', label: 'Nom', render: (row) => row.label?.fr, sortable: true, sortValue: (row) => row.label?.fr || '' },
  {
    key: 'categoryId',
    label: 'Catégorie',
    render: (row) => categories.find((cat) => cat.id === row.categoryId)?.label.fr || row.categoryId,
    sortable: true,
    sortValue: (row) => categories.find((cat) => cat.id === row.categoryId)?.label.fr || row.categoryId || ''
  }
];

export const getTechnologyFields = (categories) => [
  { name: 'label', label: 'Nom', type: 'bilingual', required: true },
  { name: 'icon', label: 'Icône', type: 'asset' },
  {
    name: 'categoryId',
    label: 'Catégorie',
    type: 'select',
    required: true,
    options: categories.map((cat) => ({ value: cat.id, label: cat.label.fr }))
  }
];
